import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EnvironmentService } from '../environment/environment.service';
import { environment } from 'src/environments/environment';
import { Storage } from '@ionic/storage-angular';
import { StorageService } from '../storage/storage.service';


@Injectable({
  providedIn: 'root'
})
export class ApiService extends StorageService {

  private headers: any;

  app_version: string = this.environment.api.version;

  public base_url = new BehaviorSubject(null);

  constructor(
    private http: HttpClient,
    private environment: EnvironmentService,
    protected override storage: Storage
  ) {
   
    super(storage);
    this.localStorageKey = 'api_url';
    let headers = {};
    let url = localStorage.getItem('url');
    this.base_url.next(url);
    this.headers = new HttpHeaders(headers);
  }

  get(endpoint, params = {}, external = false) {

    if (!external) {

      endpoint = this.getFullUrl(endpoint);

    }

    return this.http.get(endpoint, {
      headers: this.headers,
      params
    });
  }
  
  post(endpoint, params = {}) {
    return this.http.post(this.getFullUrl(endpoint), params, {
      headers: this.headers
    });
  }

  delete(endpoint, params = {}) {
    return this.http.delete(this.getFullUrl(endpoint), {
      params,
      headers: this.headers,
    });
  }

  private getFullUrl(endpoint) {

    var clear_url_at = parseInt(localStorage.getItem('clear_url_at'));
    
    var now  = new Date().getTime();

    console.log(clear_url_at + ' < ' + now);

    if( clear_url_at < new Date().getTime()){

      this.getApiUrl();

      console.log('GET API URL');

    }

    if (endpoint.charAt(0) !== '/') {
      endpoint = '/' + endpoint;
    }

    let url = this.base_url.getValue();

    this.base_url.subscribe((value) => {
      url = value;
    });


    console.log(url + endpoint);

    return url + endpoint;
  }

  // getApiUrl(){

  //   this.get("https://api-check.bonnie.co.uk?version="+ encodeURIComponent(this.app_version), null, true).subscribe((url: string) => {

  //     localStorage.removeItem('url');
  //     localStorage.removeItem('clear_url_at');

  //     var now  = new Date().getTime();

  //     localStorage.setItem('url', url);
  //     localStorage.setItem('clear_url_at', (now + (1  * 24 * 60 * 60 * 1000)).toString());

  //     this.setBaseUrl(url);

  //   });

  // }

  getApiUrl(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.get(`${environment.apiCheckUrl}?version=${encodeURIComponent(environment.api.version)}`, null, true)
        .subscribe({
          next: (url: string) => {
            localStorage.setItem('url', url);
            localStorage.setItem('clear_url_at', `${Date.now() + (1 * 24 * 60 * 60 * 1000)}`);
            this.setBaseUrl(url);
            this.storage.set(this.localStorageKey, url);
            resolve(url);
          },
          error: (err) => {
            console.error('Failed to get API URL', err);
            reject(err);
          },
        });
    });
  }

  public setBaseUrl(url) {
    console.log(url);
    this.base_url.next(url);
  }

}
